module.exports = __webpack_public_path__ + "static/media/search-find-zoom-svgrepo-com.5c01a04f.svg";